import { useState } from "react";

import { loadIssuedDetailForReturn } from "../services/returnIndentServise";

const useLoadReturnIssueDetailByRequestNumber = () => {
    const [issueIndentDetail, setIssueIndentDetail] = useState([]);

    // Fetch department data
    const fetchIssueDetail = async (selectedID = null, return_indent_number) => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plantid: 1,
            p_id_issue: selectedID,
            p_return_issue_indent_number: return_indent_number,
        };

        try {
            const data = await loadIssuedDetailForReturn(para);
            if (data && data.length > 0) {
                setIssueIndentDetail(data);

            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Function to load department based on selected ID
    const loadIssueDetailByIssueID = async (selectedID, return_indent_number) => {
        await fetchIssueDetail(selectedID, return_indent_number);
    };

    return {
        issueIndentDetail,
        loadIssueDetailByIssueID,
    };
};

export default useLoadReturnIssueDetailByRequestNumber;